/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import './LeftNav.css';
import { getClassNameFactory } from '@dcl/ui';
import { ILeftNav } from '../../types';
import { roleGroup, roleTree, roleTreeitem } from '../../../../constants';

export const Leftnav: React.FC<ILeftNav> = (props) => {
    const { leftNavItems, scrollToId } = props;
    const [activeItem, setActiveItem] = useState<string | null>(leftNavItems ? leftNavItems[0].leftNavId : null);

    const handleItemClick = (leftNavId: string) => {
        setActiveItem(leftNavId);
        scrollToId(leftNavId);
    };

    const handleEnterPress = (e: React.KeyboardEvent, leftNavId: string) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent default click behavior
            setActiveItem(leftNavId);
        }
    }

    const getClassName = getClassNameFactory(Leftnav.displayName);
    return (
        <div className={getClassName({ descendantName: "content-container" })} aria-labelledby="content-heading">
            <h2 id={getClassName({ descendantName: "content-heading" })}>Content sections</h2>
            <ul className={getClassName({ descendantName: "content-list" })} role={roleTree}>
                {leftNavItems && leftNavItems.map((item, value) => (
                    <li
                        className={getClassName({ descendantName: "contentlistItems" })}
                        aria-owns={`role_` + value}
                        key={item.leftNavId}>
                        <div id={`#${item.leftNavId}`}
                            role={roleTreeitem} tabIndex={0}
                            onClick={() => handleItemClick(item.leftNavId)}
                            onKeyDown={(e) => handleEnterPress(e, item.leftNavId)}
                            aria-selected={activeItem === item.leftNavId}
                            className={getClassName({ descendantName: "contentlistItem-anchor", modifiers: activeItem === item.leftNavId ? "active" : "" })}>
                            {item.leftNavName}</div>

                        {item.subNav && (
                            <ul className={getClassName({ descendantName: "sub-content" })} role={roleGroup} id={`role_` + value}>
                                {item.subNav.map((subItem) => (
                                    <li className={getClassName({ descendantName: "sub-content-list" })}
                                        key={subItem.subNavId}>
                                        <div id={`#${subItem.subNavId}`}
                                            role={roleTreeitem} tabIndex={0}
                                            onClick={() => handleItemClick(subItem.subNavId)}
                                            onKeyDown={(e) => handleEnterPress(e, subItem.subNavId)}
                                            aria-selected={activeItem === subItem.subNavId}
                                            className={getClassName({
                                                descendantName: "subContentlistItem-anchor",
                                                modifiers: activeItem === subItem.subNavId ? "active" : ""
                                            })}>{subItem.subNavName}</div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    )
};

Leftnav.displayName = 'Leftnav';